// extracted by mini-css-extract-plugin
module.exports = {"container":"ServiceExp_container__3K98L","coverImg":"ServiceExp_coverImg__34w_r","title":"ServiceExp_title__6Ex4b","content":"ServiceExp_content__1EyqJ"};